export class ContentPageDetailModel {
    title: string;
    subTitle: string;
    content: string;
}



// WEBPACK FOOTER //
// ./src/models/contentPage/content.page.detail.model.ts